import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { TareId } from 'Components/Worksheets/Core/Fields/TareId';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { createDryMassEntryOptionSelector } from '..';
import { DateTimeInput, Field, NumericInput, TextOutput } from '../../../Core';
import { ListFieldSection } from '../../../Layout';

let MeasurementsSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const showTimeInOven = useSelector(
    pipe(createDryMassEntryOptionSelector(createWorksheetSelector!), (v) => v !== 'Never')
  );

  return (
    <ListFieldSection>
      <TareId name="DryingTray.ContainerLabel" />
      <Field input={<NumericInput />} name="DryingTray.ContainerMass" />
      <Field input={<NumericInput />} name="DryingTray.WetSoilAndContainerMass" />
      <Field input={<TextOutput />} name="DryingTray.WetSoilMass" />
      {showTimeInOven && <Field input={<DateTimeInput />} name="DryingTray.DateTimePlacedInOvenLocal" />}
    </ListFieldSection>
  );
};
MeasurementsSection = withInjectedProps(MeasurementsSection);
export { MeasurementsSection };
export default MeasurementsSection;
